function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { expandRows } from '../utils';
import { useGetLatest, actions, useMountedLayoutEffect, makePropGetter, ensurePluginOrder } from '../publicUtils'; // Actions

actions.resetExpanded = 'resetExpanded';
actions.toggleRowExpanded = 'toggleRowExpanded';
actions.toggleAllRowsExpanded = 'toggleAllRowsExpanded';
export var useExpanded = function useExpanded(hooks) {
  hooks.getToggleAllRowsExpandedProps = [defaultGetToggleAllRowsExpandedProps];
  hooks.getToggleRowExpandedProps = [defaultGetToggleRowExpandedProps];
  hooks.stateReducers.push(reducer);
  hooks.useInstance.push(useInstance);
  hooks.prepareRow.push(prepareRow);
};
useExpanded.pluginName = 'useExpanded';

var defaultGetToggleAllRowsExpandedProps = function defaultGetToggleAllRowsExpandedProps(props, _ref) {
  var instance = _ref.instance;
  return [props, {
    onClick: function onClick(e) {
      instance.toggleAllRowsExpanded();
    },
    style: {
      cursor: 'pointer'
    },
    title: 'Toggle All Rows Expanded'
  }];
};

var defaultGetToggleRowExpandedProps = function defaultGetToggleRowExpandedProps(props, _ref2) {
  var row = _ref2.row;
  return [props, {
    onClick: function onClick() {
      row.toggleRowExpanded();
    },
    style: {
      cursor: 'pointer'
    },
    title: 'Toggle Row Expanded'
  }];
}; // Reducer


function reducer(state, action, previousState, instance) {
  if (action.type === actions.init) {
    return _objectSpread({
      expanded: {}
    }, state);
  }

  if (action.type === actions.resetExpanded) {
    return _objectSpread(_objectSpread({}, state), {}, {
      expanded: instance.initialState.expanded || {}
    });
  }

  if (action.type === actions.toggleAllRowsExpanded) {
    var value = action.value;
    var isAllRowsExpanded = instance.isAllRowsExpanded,
        rowsById = instance.rowsById;
    var expandAll = typeof value !== 'undefined' ? value : !isAllRowsExpanded;

    if (expandAll) {
      var expanded = {};
      Object.keys(rowsById).forEach(function (rowId) {
        expanded[rowId] = true;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        expanded: expanded
      });
    }

    return _objectSpread(_objectSpread({}, state), {}, {
      expanded: {}
    });
  }

  if (action.type === actions.toggleRowExpanded) {
    var id = action.id,
        setExpanded = action.value;
    var exists = state.expanded[id];
    var shouldExist = typeof setExpanded !== 'undefined' ? setExpanded : !exists;

    if (!exists && shouldExist) {
      return _objectSpread(_objectSpread({}, state), {}, {
        expanded: _objectSpread(_objectSpread({}, state.expanded), {}, _defineProperty({}, id, true))
      });
    } else if (exists && !shouldExist) {
      var _state$expanded = state.expanded,
          _ = _state$expanded[id],
          rest = _objectWithoutProperties(_state$expanded, [id].map(_toPropertyKey));

      return _objectSpread(_objectSpread({}, state), {}, {
        expanded: rest
      });
    } else {
      return state;
    }
  }
}

function useInstance(instance) {
  var data = instance.data,
      rows = instance.rows,
      rowsById = instance.rowsById,
      _instance$manualExpan = instance.manualExpandedKey,
      manualExpandedKey = _instance$manualExpan === void 0 ? 'expanded' : _instance$manualExpan,
      _instance$paginateExp = instance.paginateExpandedRows,
      paginateExpandedRows = _instance$paginateExp === void 0 ? true : _instance$paginateExp,
      _instance$expandSubRo = instance.expandSubRows,
      expandSubRows = _instance$expandSubRo === void 0 ? true : _instance$expandSubRo,
      _instance$autoResetEx = instance.autoResetExpanded,
      autoResetExpanded = _instance$autoResetEx === void 0 ? true : _instance$autoResetEx,
      getHooks = instance.getHooks,
      plugins = instance.plugins,
      expanded = instance.state.expanded,
      dispatch = instance.dispatch;
  ensurePluginOrder(plugins, ['useSortBy', 'useGroupBy', 'usePivotColumns', 'useGlobalFilter'], 'useExpanded');
  var getAutoResetExpanded = useGetLatest(autoResetExpanded);
  var isAllRowsExpanded = Boolean(Object.keys(rowsById).length && Object.keys(expanded).length);

  if (isAllRowsExpanded) {
    if (Object.keys(rowsById).some(function (id) {
      return !expanded[id];
    })) {
      isAllRowsExpanded = false;
    }
  } // Bypass any effects from firing when this changes


  useMountedLayoutEffect(function () {
    if (getAutoResetExpanded()) {
      dispatch({
        type: actions.resetExpanded
      });
    }
  }, [dispatch, data]);
  var toggleRowExpanded = React.useCallback(function (id, value) {
    dispatch({
      type: actions.toggleRowExpanded,
      id: id,
      value: value
    });
  }, [dispatch]);
  var toggleAllRowsExpanded = React.useCallback(function (value) {
    return dispatch({
      type: actions.toggleAllRowsExpanded,
      value: value
    });
  }, [dispatch]);
  var expandedRows = React.useMemo(function () {
    if (paginateExpandedRows) {
      return expandRows(rows, {
        manualExpandedKey: manualExpandedKey,
        expanded: expanded,
        expandSubRows: expandSubRows
      });
    }

    return rows;
  }, [paginateExpandedRows, rows, manualExpandedKey, expanded, expandSubRows]);
  var expandedDepth = React.useMemo(function () {
    return findExpandedDepth(expanded);
  }, [expanded]);
  var getInstance = useGetLatest(instance);
  var getToggleAllRowsExpandedProps = makePropGetter(getHooks().getToggleAllRowsExpandedProps, {
    instance: getInstance()
  });
  Object.assign(instance, {
    preExpandedRows: rows,
    expandedRows: expandedRows,
    rows: expandedRows,
    expandedDepth: expandedDepth,
    isAllRowsExpanded: isAllRowsExpanded,
    toggleRowExpanded: toggleRowExpanded,
    toggleAllRowsExpanded: toggleAllRowsExpanded,
    getToggleAllRowsExpandedProps: getToggleAllRowsExpandedProps
  });
}

function prepareRow(row, _ref3) {
  var getHooks = _ref3.instance.getHooks,
      instance = _ref3.instance;

  row.toggleRowExpanded = function (set) {
    return instance.toggleRowExpanded(row.id, set);
  };

  row.getToggleRowExpandedProps = makePropGetter(getHooks().getToggleRowExpandedProps, {
    instance: instance,
    row: row
  });
}

function findExpandedDepth(expanded) {
  var maxDepth = 0;
  Object.keys(expanded).forEach(function (id) {
    var splitId = id.split('.');
    maxDepth = Math.max(maxDepth, splitId.length);
  });
  return maxDepth;
}